import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FaShieldAlt, FaGlobeAmericas, FaRocket, FaLaptopCode, FaCheckCircle, FaStar } from 'react-icons/fa';

const About = () => {
  useEffect(() => {
    AOS.init({ offset: 150, duration: 1000 });
  }, []);

  return (
    <>
      <section className="about-hero" id="about">
        <div className="about-blob about-blob-1"></div>
        <div className="about-blob about-blob-2"></div>
        <div className="about-blob about-blob-3"></div>
        <div className="about-grain"></div>

        <div className="container about-hero-inner">
          <div className="row align-items-center">
            <div className="col-lg-6" data-aos="fade-up">
              <span className="about-badge">ABOUT US</span>
              <h1 className="about-hero-title">
                We Don't Just Build Software.
                <span className="about-hero-gradient">We Build Digital Legacies.</span>
              </h1>
              <p className="about-hero-story">
                <strong>Octalbees</strong> is a global Software & IT company specializing in web, app development, and UI/UX design. We partner with startups and brands to craft scalable digital products, while also running India's most hands-on internship program to train the next generation of tech talent.
              </p>
              <blockquote className="about-hero-quote">
                <span className="quote-mark">"</span>
                We don't just deliver projects — we build digital stories worth sharing.
              </blockquote>

              <div className="about-pills-row">
                <div className="about-pill" data-aos="fade-up" data-aos-delay="100">
                  <FaShieldAlt className="about-pill-icon" />
                  <span>Government Registered</span>
                </div>
                <div className="about-pill" data-aos="fade-up" data-aos-delay="150">
                  <FaShieldAlt className="about-pill-icon" />
                  <span>State Approved</span>
                </div>
                <div className="about-pill" data-aos="fade-up" data-aos-delay="200">
                  <FaGlobeAmericas className="about-pill-icon" />
                  <span>Clients Worldwide</span>
                </div>
                <div className="about-pill" data-aos="fade-up" data-aos-delay="300">
                  <FaRocket className="about-pill-icon" />
                  <span>Since 2024</span>
                </div>
              </div>
            </div>

            {/* Right — Bento Grid Visual */}
            <div className="col-lg-5 offset-lg-1 d-none d-lg-block" data-aos="fade-left" data-aos-delay="200">
              <div className="about-bento">
                <div className="bento-card bento-mission">
                  <div className="bento-card-glow"></div>
                  <FaRocket className="bento-mission-icon" />
                  <h4 className="bento-card-title">Our Mission</h4>
                  <p className="bento-card-text">Building world-class digital products that help businesses scale & succeed globally</p>
                </div>

                <div className="bento-card bento-rating">
                  <div className="bento-card-glow"></div>
                  <div className="bento-rating-stars">
                    <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
                  </div>
                  <span className="bento-rating-value">4.9</span>
                  <span className="bento-rating-label">Client Rating</span>
                </div>

                <div className="bento-card bento-projects">
                  <div className="bento-card-glow"></div>
                  <FaLaptopCode className="bento-projects-icon" />
                  <span className="bento-projects-value">50+</span>
                  <span className="bento-projects-label">Projects Shipped</span>
                </div>

                <div className="bento-card bento-trust">
                  <div className="bento-card-glow"></div>
                  <div className="bento-trust-row">
                    <FaCheckCircle className="bento-trust-check" />
                    <span>Govt. Registered</span>
                  </div>
                  <div className="bento-trust-row">
                    <FaCheckCircle className="bento-trust-check" />
                    <span>State Licensed</span>
                  </div>
                  <div className="bento-trust-row">
                    <FaCheckCircle className="bento-trust-check" />
                    <span>Global Clients</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <style>{`
        .about-hero {
          position: relative; padding: 40px 0 80px; background-color: #0c001f;
          color: #fff; overflow: hidden; min-height: auto; display: flex; align-items: center;
        }
        .about-blob {
          position: absolute; border-radius: 50%; filter: blur(120px);
          opacity: 0.5; pointer-events: none; z-index: 0;
        }
        .about-blob-1 {
          width: 600px; height: 600px;
          background: radial-gradient(circle, rgba(160, 79, 244, 0.35) 0%, transparent 70%);
          top: -15%; left: -10%; animation: blobMorph1 12s ease-in-out infinite;
        }
        .about-blob-2 {
          width: 500px; height: 500px;
          background: radial-gradient(circle, rgba(255, 180, 40, 0.2) 0%, transparent 70%);
          bottom: -20%; right: -5%; animation: blobMorph2 15s ease-in-out infinite;
        }
        .about-blob-3 {
          width: 350px; height: 350px;
          background: radial-gradient(circle, rgba(255, 180, 40, 0.15) 0%, transparent 70%);
          top: 50%; left: 40%; animation: blobMorph3 10s ease-in-out infinite;
        }
        @keyframes blobMorph1 {
          0%, 100% { transform: translate(0, 0) scale(1); }
          33% { transform: translate(60px, 40px) scale(1.15); }
          66% { transform: translate(-30px, 70px) scale(0.95); }
        }
        @keyframes blobMorph2 {
          0%, 100% { transform: translate(0, 0) scale(1); }
          33% { transform: translate(-50px, -30px) scale(1.1); }
          66% { transform: translate(40px, -60px) scale(0.9); }
        }
        @keyframes blobMorph3 {
          0%, 100% { transform: translate(0, 0) scale(1); opacity: 0.5; }
          50% { transform: translate(50px, -40px) scale(1.2); opacity: 0.3; }
        }
        .about-grain {
          position: absolute; inset: 0;
          background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.03'/%3E%3C/svg%3E");
          z-index: 0; pointer-events: none;
        }
        .about-hero-inner { position: relative; z-index: 2; }
        .about-badge {
          display: inline-block; font-size: 0.75rem; font-weight: 700;
          letter-spacing: 3px; color: #a04ff4;
          background: rgba(160, 79, 244, 0.1); padding: 7px 20px;
          border-radius: 50px; border: 1px solid rgba(160, 79, 244, 0.25);
          margin-bottom: 28px; text-transform: uppercase;
        }
        .about-hero-title {
          font-size: 3.5rem; font-weight: 800; line-height: 1.15;
          color: #fff; margin-bottom: 28px; letter-spacing: -1px;
        }
        .about-hero-gradient {
          display: block;
          background: linear-gradient(90deg, #a04ff4, #f78ef6, #ffb428);
          background-size: 200% auto;
          -webkit-background-clip: text; -webkit-text-fill-color: transparent;
          animation: gradientShift 6s ease-in-out infinite;
        }
        @keyframes gradientShift {
          0%, 100% { background-position: 0% center; }
          50% { background-position: 100% center; }
        }
        .about-hero-story {
          font-size: 1.15rem; line-height: 1.85; color: #b0b0b0;
          max-width: 620px; margin-bottom: 28px; text-align: left;
        }
        .about-hero-story strong { color: #fff; }
        .about-hero-quote {
          font-style: italic; color: #d0d0d0; font-size: 1.15rem; font-weight: 300;
          border-left: 3px solid #a04ff4; padding-left: 20px;
          margin: 0 0 36px 0; line-height: 1.7;
        }
        .quote-mark {
          font-size: 3rem; font-weight: 800;
          background: linear-gradient(135deg, #a04ff4, #ffb428);
          -webkit-background-clip: text; -webkit-text-fill-color: transparent;
          line-height: 0; vertical-align: -0.35em; margin-right: 4px;
        }
        .about-pills-row { display: flex; flex-wrap: wrap; gap: 12px; }
        .about-pill {
          display: inline-flex; align-items: center; gap: 8px;
          background: rgba(255, 255, 255, 0.04); border: 1px solid rgba(255, 255, 255, 0.08);
          padding: 10px 20px; border-radius: 50px;
          font-size: 0.88rem; font-weight: 600; color: #d0d0d0; transition: all 0.3s ease;
        }
        .about-pill:hover {
          border-color: rgba(160, 79, 244, 0.4); background: rgba(160, 79, 244, 0.08);
          transform: translateY(-2px);
        }
        .about-pill-icon { color: #a04ff4; font-size: 0.9rem; }

        /* ─── Bento Grid ─── */
        .about-bento {
          display: grid; grid-template-columns: 1.4fr 1fr;
          gap: 16px;
        }
        .bento-card {
          background: rgba(255, 255, 255, 0.03); border: 1px solid rgba(255, 255, 255, 0.06);
          border-radius: 18px; padding: 24px; position: relative; overflow: hidden;
          transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275); backdrop-filter: blur(10px);
        }
        .bento-card:hover {
          transform: translateY(-4px); border-color: rgba(160, 79, 244, 0.3);
          box-shadow: 0 15px 40px rgba(0, 0, 0, 0.35);
        }
        .bento-card-glow {
          position: absolute; top: 0; left: 0; right: 0; height: 2px;
          background: linear-gradient(90deg, transparent, rgba(160, 79, 244, 0.4), transparent);
          opacity: 0; transition: opacity 0.3s ease;
        }
        .bento-card:hover .bento-card-glow { opacity: 1; }
        .bento-mission {
          grid-column: 1 / -1; text-align: center;
          background: linear-gradient(135deg, rgba(160, 79, 244, 0.06), rgba(255, 180, 40, 0.04));
        }
        .bento-mission-icon { font-size: 1.8rem; color: #a04ff4; margin-bottom: 10px; display: block; margin-left: auto; margin-right: auto; }
        .bento-card-title { font-size: 1.1rem; font-weight: 700; color: #fff; margin: 0 0 6px 0; }
        .bento-card-text { font-size: 0.9rem; color: #a0a0a0; margin: 0; line-height: 1.5; text-align: center; }
        .bento-rating { text-align: center; }
        .bento-rating-stars {
          display: flex; gap: 3px; justify-content: center; color: #ffb428;
          font-size: 0.75rem; margin-bottom: 8px;
        }
        .bento-rating-value { display: block; font-size: 2.2rem; font-weight: 800; color: #fff; line-height: 1; }
        .bento-rating-label {
          display: block; font-size: 0.75rem; color: #6a6a6a;
          text-transform: uppercase; letter-spacing: 1px; margin-top: 4px; font-weight: 600;
        }
        .bento-projects { text-align: center; }
        .bento-projects-icon { font-size: 1.4rem; color: #ffb428; margin-bottom: 8px; display: block; margin-left: auto; margin-right: auto; }
        .bento-projects-value { display: block; font-size: 2.2rem; font-weight: 800; color: #fff; line-height: 1; }
        .bento-projects-label {
          display: block; font-size: 0.75rem; color: #6a6a6a;
          text-transform: uppercase; letter-spacing: 1px; margin-top: 4px; font-weight: 600;
        }
        .bento-trust {
          grid-column: 1 / -1; display: flex; gap: 20px; justify-content: center; flex-wrap: wrap;
          padding: 18px 24px; background: rgba(255, 180, 40, 0.03); border-color: rgba(255, 180, 40, 0.08);
        }
        .bento-trust-row {
          display: flex; align-items: center; gap: 8px;
          font-size: 0.88rem; font-weight: 500; color: #c0c0c0;
        }
        .bento-trust-check { color: #ffb428; font-size: 0.8rem; }

        @media (max-width: 991px) {
          .about-hero { padding: 40px 0 80px; min-height: auto; }
          .col-lg-6 { text-align: center; }
          .about-hero-title { font-size: 2.8rem; text-align: center; }
          .about-pills-row { justify-content: center; }
          .about-hero-story, .about-hero-quote { text-align: center; margin-left: auto; margin-right: auto; }
          .about-badge { display: inline-block; text-align: center; margin: 0 auto 28px; }
        }
        @media (max-width: 576px) {
          .about-hero { padding: 20px 0 60px; }
          .about-hero-title { font-size: 2.2rem; }
          .about-hero-story { font-size: 1rem; }
          .about-hero-quote { font-size: 1rem; }
          .about-pill { font-size: 0.8rem; padding: 8px 14px; }
        }
      `}</style>
    </>
  );
};

export default About;